import { configureStore } from "@reduxjs/toolkit";
// app functionality
import pageProperties from "./features/appFunctionality/pageProperties";
import snackBar from "./features/appFunctionality/snackbar";

// auth
import currentAuthUser from "./features/auth/authUser";

//user login credentials store import
import AppAuthStatus from "./features/authentication/loginStatus";
import accessToken from "./features/authentication/accessToken";
import myRole from "./features/user/userRoles";

// import userProfileReducer from "./features/get_user_profile";
import annotationData from "./features/crop_doctor_annotations";
import analyticsToggle from "./features/firebase_analytics";

//import crop family
import post_crop_family from "./features/cropFamily/post_crop_family";
import update_crop_family from "./features/cropFamily/update_crop_family";
import get_crop_family from "./features/cropFamily/get_crop_family";
import crop_family_image_library from "./features/cropFamily/image_library";

//import soil type
import get_soil_type from "./features/soilType/get_soil_type";

//import disease Type
import post_Disease_Type from "./features/diseaseType/post_disease_type";
import update_Disease_Type from "./features/diseaseType/update_disease_type";
import get_disease_type from "./features/diseaseType/get_diseaseType";
import disease_type_image_library from "./features/diseaseType/image_library";

//import growth stages of infection
import post_Growth_Stages from "./features/growthInfection/post_growth_stages";
import update_Growth_Stages from "./features/growthInfection/update_growth_stages";
import get_Growth_Stages from "./features/growthInfection/get_growthStages";
import growth_stages_image_library from "./features/growthInfection/image_library";

//import crop information details
import cropsLists from "./features/crops/crops-list";
import get_crops from "./features/crops/get_crops";
import update_Crop_Info from "./features/crops/update_crop_information";
import post_Crop_Info from "./features/crops/post_crop_information";
import crops_image_library from "./features/crops/crops_img_library";

//import disease information details
import diseasesLists from "./features/diseases/diseases-list";
import get_disease from "./features/diseases/get_diseases";
import update_disease_information from "./features/diseases/update_disease_information";
import post_Disease_Info from "./features/diseases/post_disease_information";
import disease_img_library from "./features/diseases/disease_img_library";
import updateMainCropAffected from "./features/diseases/mainAffectedCrop";

//import pests information details
import get_pests from "./features/pests/get_pest";
import update_pest_information from "./features/pests/update_pest_information";
import post_pests_Info from "./features/pests/post_pest_information";
import pests_image_library from "./features/pests/pest_img_library";
import updatePestsMainCropAffected from "./features/pests/mainAffectedCrop";
import pestsLists from "./features/pests/pests-list";
import pestSpecificsLists from "./features/pests/pest-specifics-list";

// import new pest preview and pest specific slices
import post_pest_preview_Info from "./features/pests/post_pest_preview_information";
import update_pest_preview_information from "./features/pests/update_pest_preview_information";
import post_pest_specific_Info from "./features/pests/post_pest_specific_information";
import update_pest_specific_information from "./features/pests/update_pest_specific_information";

//import crop/disease name
import manageAllSingleStates from "./features/manageSingleStates";

// language map images
import langMapImages from "./features/imageLibrary/langMapImages";
import blogLangMapImages from "./features/imageLibrary/blogLangMapImages";
import notificationsLangMapImages from "./features/imageLibrary/notificationsLangMapImages";

//farms
import farm_name_and_ownership from "./features/farms/farmName&Ownership";
import all_user_farms from "./features/farms/getAllFarms";
import all_farm_fields from "./features/farms/getFarmFields";
import selectedCrop from "./features/farms/selectedCrop";
import selectedActivity from "./features/farms/selectedActivity";
import newSeasonSelectedCrops from "./features/farms/newSeasonCrops";
import harvestYourCrop from "./features/farms/harvestCrop";
import farmFieldsById from "./features/farms/getSingleField";

//enterprise weather
import weatherPage from "./features/weather/weatherPage";
import enterpriseWeather from "./features/weather/enterpriseWeather";
import farmDetailedWeather from "./features/weather/detailedFarmWeather";

//user
import ProfileSetup from "./features/user/profileSetup";
import InfoBox from "./features/infoBox";
import ActionRequiredIndicator from "./features/actionIndicatorPrompt";

//chats
import chatSocketInstance from "./features/chat/socketInstance";
import notificationSocketInstance from "./features/notifications/socketInstance";
import privateChat from "./features/chat/privateChat";
import communityChatV1 from "./features/chat/communityChat_v1";

//app notifications
import appNotification from "./features/notification";

//show prompt on too many request and on close, log user out.
import onTooManyRequest from "./features/429ErrorPrompt";
import NetworkError from "./features/networkPrompt";

//admins
import newAdminData from "./features/admins/newAdminData";
import deletedUsersData from "./features/admins/deleted-users";
import subscribedUsersData from "./features/admins/subscribed-users";
import deletedFarmsData from "./features/admins/deleted-farms";
import deletedFieldsData from "./features/admins/deleted-fields";
import deletedFieldCropsData from "./features/admins/deleted-field-crops";
import reverseGeocodedFarmsData from "./features/admins/reverse-geocoded-farms";
import notificationsLists from "./features/admins/notifications-lists";
import currentlyCultivatedCrops from "./features/admins/currently-cultivated-crops";
import listedDiseasesData from "./features/admins/listed-diseases";

//blog cms
import new_blog from "./features/blog-cms/new_blog";
import blog_tags from "./features/blog-cms/blog_tags";
import update_Blog_Post from "./features/blog-cms/update_blog";
import get_blogs from "./features/blog-cms/get_blogs";
import blog_image_library from "./features/blog-cms/blog_img_library";

// notifications
import new_notification from "./features/notifications/new_notifications";
import update_Notifications_Post from "./features/notifications/update_notification";
import get_notifications from "./features/notifications/get_notification";
import notification_image_library from "./features/notifications/notification_img_library";

//auxilliary  functions for use in other features
import LibraryTab from "./features/app-auxiliary-feaures/libraryTab";

export const MainStore = () => {
  return configureStore({
    reducer: {
      //app functionality
      pageProperties: pageProperties,
      snackbar: snackBar,

      // auth
      currentAuthUser: currentAuthUser,
      //admins
      newAdmins: newAdminData,
      deletedUsers: deletedUsersData,
      subsribedUsers: subscribedUsersData,
      deletedFarms: deletedFarmsData,
      deletedFields: deletedFieldsData,
      deletedFieldCrops: deletedFieldCropsData,
      reverserGeocodeFarmsData: reverseGeocodedFarmsData,
      notificationsList: notificationsLists,
      currentlyCultivatedCrops: currentlyCultivatedCrops,
      listedDiseases: listedDiseasesData,
      //user login credentials
      userAuthState: AppAuthStatus,
      userToken: accessToken,
      authUserRole: myRole,
      //crop family
      postCropFamily: post_crop_family,
      updateCropFamily: update_crop_family,
      getCropFamily: get_crop_family,
      getCropFamilyImgLibrary: crop_family_image_library,

      //disease type
      postDiseaseType: post_Disease_Type,
      updateDiseaseType: update_Disease_Type,
      getDiseaseType: get_disease_type,
      getDiseaseTypeImgLibrary: disease_type_image_library,

      //growth stages of infection
      postGrowthStages: post_Growth_Stages,
      updateGrowthStages: update_Growth_Stages,
      getGrowthStages: get_Growth_Stages,
      getGrowthStageImgLibrary: growth_stages_image_library,

      //crop information
      cropLists: cropsLists,
      postCropInfo: post_Crop_Info,
      updateCropInfo: update_Crop_Info,
      getCropInfo: get_crops,
      getCropImgLibrary: crops_image_library,

      //disease information data
      dieasesLists: diseasesLists,
      postDiseaseInfo: post_Disease_Info,
      updateDiseaseInfo: update_disease_information,
      getDiseaseInfo: get_disease,
      getDiseaseImgLibrary: disease_img_library,
      getMainCropAffected: updateMainCropAffected,

      //pests information data
      pestsLists: pestsLists,
      pestSpecificsLists: pestSpecificsLists,
      postPestsInfo: post_pests_Info,
      updatePestsInfo: update_pest_information,
      getPestsInfo: get_pests,
      getPestsImgLibrary: pests_image_library,
      getPestsMainCropAffected: updatePestsMainCropAffected,

      // pest preview and pest specific data
      postPestPreviewInfo: post_pest_preview_Info,
      updatePestPreviewInfo: update_pest_preview_information,
      postPestSpecificInfo: post_pest_specific_Info,
      updatePestSpecificInfo: update_pest_specific_information,

      //image library
      langMapImages: langMapImages,
      blogLangMapImages: blogLangMapImages,
      notitificationLangMapImages: notificationsLangMapImages,

      //soil type information data
      getSoilType: get_soil_type,

      //farms
      getFarmName: farm_name_and_ownership,
      getUserFarms: all_user_farms,
      getFarmFields: all_farm_fields,
      getSingleField: farmFieldsById,

      //app notifications
      notification: appNotification,
      getNotificationSocketInstance: notificationSocketInstance,
      //chats
      getSocketInstance: chatSocketInstance,
      getPrivateChat: privateChat,
      communityChatV1: communityChatV1,

      //user
      getProfileSetup: ProfileSetup,

      //field setup
      harvestedCropData: harvestYourCrop,
      getSelectedCrop: selectedCrop,
      getSelectedActivity: selectedActivity,
      getNewSeasonSelectedCrops: newSeasonSelectedCrops,

      //weather data
      getWeatherPage: weatherPage,
      getEnterpriseWeather: enterpriseWeather,
      getFarmDetailedWeather: farmDetailedWeather,
      //miscellaneus stores
      //end of store to set new crop name
      getInfoBoxMessage: InfoBox,
      actionIndicator: ActionRequiredIndicator,
      isNetworkError: NetworkError,
      cropImgAnnotation: annotationData,
      firebaseAnalytics: analyticsToggle,

      //notifications
      newNotification: new_notification,
      updateNotificationPost: update_Notifications_Post,
      getNotifications: get_notifications,
      getNotificationImgLibrary: notification_image_library,

      //blog cms
      newBlog: new_blog,
      blogTags: blog_tags,
      updateBlogPost: update_Blog_Post,
      getBlogs: get_blogs,
      getBlogImgLibrary: blog_image_library,

      //auxiliary features
      libraryTab: LibraryTab,
      //manage all single state services in the app
      //crop name state
      //account linking action boolean
      error429Prompt: onTooManyRequest,
      singleState: manageAllSingleStates,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
  });
};
// Infer the type of makeStore
export type AppStore = ReturnType<typeof MainStore>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
